/* eslint-disable camelcase */
type Locale = 'en' | 'es';
interface Vars {
  contentType: string | null;
}

type Phrase = (l: Locale, vars: Vars) => string;

export const i18n_remove_from_my_x: Phrase = (locale, { contentType }) => {
  const pluralContent = contentType !== 'Pranayama';

  const phrases: { [key: string]: undefined | string } = {
    en: `Remove from My ${contentType || 'Library'}`,
    es: `Eliminar de Mi${pluralContent ? 's' : ''} ${contentType || 'Biblioteca'}`,
  };
  return phrases[locale] || phrases.en || '';
};
